export default "__VITE_ASSET__Ccm3o3Fs__"